import { takeLatest, call, put } from 'redux-saga/effects';
import { FETCH_CONTENT, HIDE_CONTENT, UNHIDE_CONTENT } from './constants';
import { toastr } from '../../utils/notifications';
import i18n from '../../i18n';
import {
  fetchContentSuccess,
  fetchContentFailure,
  hideContentSuccess,
  unhideContentSuccess,
} from './actions';
import LinksService from '../../api/services/LinksService';

function* getContent() {
  try {
    const content = yield call([LinksService, 'fetchContent']);
    yield put(fetchContentSuccess(content));
  } catch (error) {
    toastr.error(i18n.t('toastr:error'), i18n.t('pages:featuredArtist.fetchErrorMessage'));

    yield put(fetchContentFailure());
  }
}

function* hideContent(action) {
  const { uid } = action.payload;

  try {
    yield call([LinksService, 'hideContent'], uid);
    yield put(hideContentSuccess(uid));
  } catch (error) {
    toastr.error(i18n.t('toastr:error'), i18n.t('pages:featuredArtist.hideErrorMessage'));
  }
}

function* unhideContent(action) {
  const { uid } = action.payload;

  try {
    yield call([LinksService, 'unhideContent'], uid);
    yield put(unhideContentSuccess(uid));
  } catch (error) {
    toastr.error(i18n.t('toastr:error'), i18n.t('pages:featuredArtist.unhideErrorMessage'));
  }
}

export const linksSagas = [
  takeLatest(FETCH_CONTENT, getContent),
  takeLatest(HIDE_CONTENT, hideContent),
  takeLatest(UNHIDE_CONTENT, unhideContent),
];
